import { Timestamp } from "firebase/firestore";
import { useState, useCallback } from "react";
import { Button, Card } from "react-bootstrap";
import { useCollection } from "react-firebase-hooks/firestore";
import DeleteModal from "../components/DeleteBusiness";
import EditLifestyle from "../components/EditLifestyle";
import { Loader } from "../hooks/useLoading";
import { LIFESTYLE } from "../utils/constants";
import { lifestyleQuery } from "../utils/queryHelpers";
import { useNavigate } from "react-router-dom";
import { useMyContext } from "../contextProvider/contentTypeProvider";

const LifestylePage = () => {
  const { contextState, updateContextState } = useMyContext();
  const navigate = useNavigate();
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [status, setstatus] = useState(
    contextState?.lifestyle?.status || "Active"
  );
  const [dialogType, setDialogType] = useState("Add");
  const date = new Date();
  const todayTimestamp = Timestamp.fromDate(
    new Date(date.getFullYear(), date.getMonth(), date.getDate())
  );
  const [time, setTime] = useState(todayTimestamp);
  const [snapshot, loading, error] = useCollection(
    lifestyleQuery(status, time),
    {
      snapshotListenOptions: {
        includeMetadataChanges: true,
      },
    }
  );

  const onDeleteModalClose = useCallback(() => {
    setShowDeleteModal(false);
    setSelected(null);
  }, []);

  return (
    <>
      <header className="d-flex  justify-content-between mb-3">
        <h4>Lifestyle</h4>
        <div className="d-flex gap-2">
          <select
            className="form-control"
            value={status}
            onChange={(e) => {
              updateContextState({
                lifestyle: { status: e.target.value },
              });

              setstatus(e.target.value);
              setTime(todayTimestamp);
            }}
          >
            <option value="Active">Active</option>
            <option value="Expired">Expired</option>
          </select>
          <button
            className="btn btn-dark"
            onClick={() => {
              setShowEditModal(true);
              setDialogType("Add");
            }}
          >
            Add
          </button>
        </div>
      </header>
      <main className="d-flex gap-1 flex-wrap">
        {loading && <Loader />}
        {error ? (
          <p className="text-error">
            There is some error. Please try again later
          </p>
        ) : null}
        {snapshot?.docs.length < 1 ? (
          <p className="text-center flex-fill"> No Data Available</p>
        ) : null}
        {snapshot?.docs.map((data) => {
          const d = { ...data.data(), id: data.id };
          return (
            <Card style={{ width: "18rem" }} key={d.id}>
              <Card.Img
                variant="top"
                src={d.image_url}
                style={{
                  width: "100%",
                  height: "150px",
                  objectFit: "contain",
                }}
                className="bg-dark"
              />
              <Card.Body>
                <Card.Title>{d.title}</Card.Title>
                <Card.Text>
                <a
                  href={d.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary text-decoration-underline"
                >
                  {d.link}
                </a>
              </Card.Text>
                <div className="d-flex gap-1">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      navigate(`${d.id}`);
                    }}
                  >
                    View
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => {
                      setSelected(d);
                      setShowEditModal(true);
                      setDialogType("Edit");
                    }}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() => {
                      setSelected(d);
                      setShowDeleteModal(true);
                    }}
                  >
                    Delete
                  </Button>
                </div>
              </Card.Body>
            </Card>
          );
        })}
      </main>
      {showEditModal ? (
        <EditLifestyle
          onClose={() => {
            setShowEditModal(false);
            setSelected(null);
          }}
          prevData={selected}
          dialogType={dialogType}
        />
      ) : null}
      {showDeleteModal ? (
        <DeleteModal
          onClose={onDeleteModalClose}
          data={selected}
          type={LIFESTYLE}
        />
      ) : null}
    </>
  );
};

export default LifestylePage;
